function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { TOUR_DONE_MODAL } from '../../../../../components/modal/TourDoneModal';
import { showModal } from '../../../../../redux/actions';
import text from '../../../../../text';
import { store } from '../../../../../utilities/store';
import { StepContent } from './TourContent';
import { hightlightedAreaStyling, popoverCustomDefaultStyling } from './config';
export var TOUR_FILE_MANAGER = [
    {
        selector: '.Activity',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tourFileManagerStep1Title'),
                description: text('tourFileManagerStep1')
            });
        },
        position: 'bottom',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginTop: '16px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'top'
        }
    },
    {
        selector: '#ActivityFilterControls-tour',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tourFileManagerStep2Title'),
                description: text('tourFileManagerStep2')
            });
        },
        position: 'bottom',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginTop: '16px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'top'
        }
    },
    {
        selector: '.Controls',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tourFileManagerStep3Title'),
                description: text('tourFileManagerStep3')
            });
        },
        position: 'bottom',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginTop: '16px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'top',
            callback: {
                next: function() {
                    store.dispatch(showModal(TOUR_DONE_MODAL));
                }
            }
        }
    }
];
